/**
 * Auth API paths and constants - single source of truth for auth endpoints and storage keys
 */

import { env } from '@/lib/env'

/** Session/localStorage key for API access token */
export const API_AUTH_TOKEN_STORAGE_KEY = 'em_semi_access_token'

/** SessionStorage key for post-login redirect path */
export const AUTH_REDIRECT_STORAGE_KEY = 'auth_redirect_path'

/** Default route after login when no redirect is stored */
export const DEFAULT_REDIRECT_PATH = '/workflows'

const API_VERSION = 'v2'

function getApiBaseUrl(): string {
  return env.apiBaseUrl
}

function buildApiUrl(path: string): string {
  const baseUrl = getApiBaseUrl().replace(/\/$/, '')
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `${baseUrl}${cleanPath}`
}

const authPathDefinitions = {
  login: `/api/${API_VERSION}/auth/login`,
  register: `/api/${API_VERSION}/auth/register`,
  forgotPassword: `/api/${API_VERSION}/auth/forgot-password`,
  health: `/api/${API_VERSION}/auth/health`,
  session: `/api/${API_VERSION}/auth/session`,
  me: `/api/${API_VERSION}/auth/me`,
  profileImage: (userId: string) => `/api/${API_VERSION}/user/${userId}/profile-image`,
  userMe: `/api/${API_VERSION}/user/me`,
} as const

/** Full auth API URLs (for fetch) */
export const apiPathsAuth = {
  login: () => buildApiUrl(authPathDefinitions.login),
  register: () => buildApiUrl(authPathDefinitions.register),
  forgotPassword: () => buildApiUrl(authPathDefinitions.forgotPassword),
  health: () => buildApiUrl(authPathDefinitions.health),
  session: () => buildApiUrl(authPathDefinitions.session),
  me: () => buildApiUrl(authPathDefinitions.me),
  profileImage: (userId: string) => buildApiUrl(authPathDefinitions.profileImage(userId)),
  userMe: () => buildApiUrl(authPathDefinitions.userMe),
} as const

/** Relative auth path keys (for query keys) */
export const apiPathKeysAuth = {
  login: () => authPathDefinitions.login,
  register: () => authPathDefinitions.register,
  forgotPassword: () => authPathDefinitions.forgotPassword,
  health: () => authPathDefinitions.health,
  session: () => authPathDefinitions.session,
  me: () => authPathDefinitions.me,
  profileImage: (userId: string) => authPathDefinitions.profileImage(userId),
  userMe: () => authPathDefinitions.userMe,
} as const
